<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{ path: BACKEND_URL + '/participants/edit/' + participant.id, props: { id: participant.id } }"
        v-if="$can('participant-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(participant.id)" v-if="$can('participant-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="participant.first_name"
                  :label="$t('participants.first_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="participant.last_name"
                  :label="$t('participants.last_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="participant.email"
                  :label="$t('participants.email')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="participant.mobile"
                  :label="$t('participants.mobile')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="participant.date_of_birth"
                  :value="computedDateofBirth"
                  :label="$t('participants.date_of_birth')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("participants.address_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="participant.street"
                  :label="$t('participants.street')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="participant.city"
                  :label="$t('participants.city')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="participant.state"
                  :label="$t('participants.state')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field v-model="participant.zip" :label="$t('participants.zip')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="participant.country"
                  :value="this.$dd_countries(participant.country)"
                  :label="$t('participants.country')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("courses.title") }}</v-toolbar-title>
          </v-app-bar>

          <v-divider></v-divider>

          <v-card-text>
            <v-flex md12>
              <v-data-table
                :headers="course_headers"
                :items="courses"
                :items-per-page="courses.length"
                :options.sync="course_pagination"
                :footer-props="{
                  'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                  'items-per-page-all-text': $t('global.items_per_page_all_text'),
                  'items-per-page-text': $t('global.items_per_page_text'),
                  'page-text': $t('global.page_text')
                }"
                :server-items-length="course_total"
                :loading="course_show_loading"
                :loading-text="$t('global.loading_text')"
                :no-data-text="$t('global.no_data_text')"
                :no-results-text="$t('global.no_results_text')"
                :must-sort="true"
              >
                <template v-slot:item.name="{ item }">
                  {{ item.course.name }}
                </template>

                <template v-slot:item.start_datetime="{ item }">
                  {{
                    item.course.start_date
                      ? moment.utc(item.course.start_date).format(DATE_FORMAT) +
                        " " +
                        moment.utc(item.course.start_time, TIME_FORMAT).format(TIME_FORMAT)
                      : null
                  }}
                </template>

                <template v-slot:item.end_datetime="{ item }">
                  {{
                    item.course.end_date
                      ? moment.utc(item.course.end_date).format(DATE_FORMAT) +
                        " " +
                        moment.utc(item.course.end_time, TIME_FORMAT).format(TIME_FORMAT)
                      : null
                  }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <router-link
                    :to="{ path: BACKEND_URL + '/courses/view/' + item.course.id, props: { id: item.course.id } }"
                    v-if="$can('course-access')"
                  >
                    <action-button type="view" :icon_only="true" small />
                  </router-link>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("certificates.modulename") }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <router-link
              :to="{ path: BACKEND_URL + '/certificates/create?from_module=participants&from_id=' + this.participant.id }"
              v-if="$can('certificate-create')"
            >
              <action-button type="new" small :icon_only="true" />
            </router-link>
          </v-app-bar>

          <v-divider></v-divider>

          <v-card-text>
            <v-flex md12>
              <v-data-table
                :headers="certificate_headers"
                :items="certificates"
                :items-per-page="certificates.length"
                :options.sync="certificate_pagination"
                :footer-props="{
                  'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                  'items-per-page-all-text': $t('global.items_per_page_all_text'),
                  'items-per-page-text': $t('global.items_per_page_text'),
                  'page-text': $t('global.page_text')
                }"
                :server-items-length="certificate_total"
                :loading="certificate_show_loading"
                :loading-text="$t('global.loading_text')"
                :no-data-text="$t('global.no_data_text')"
                :no-results-text="$t('global.no_results_text')"
                :must-sort="true"
              >
                <template v-slot:item="{ item, index }">
                  <tr
                    v-for="(row, idx) in item.row_titles"
                    :key="item.id + '-' + idx"
                    :class="item.row_titles && item.row_titles.length > 1 ? 'grouped ' + (index % 2 == 1 ? 'odd' : 'even') : ''"
                  >
                    <td>{{ item.row_titles[idx] }}</td>
                    <td>{{ item.issued_date ? moment.utc(item.issued_date).format(DATE_FORMAT) : null }}</td>
                    <td>{{ item.issued_by }}</td>
                    <td>{{ item.course_held_by }}</td>
                    <td class="text-end">
                      <router-link
                        :to="{ path: BACKEND_URL + '/certificates/view/' + item.id, props: { id: item.id } }"
                        v-if="$can('certificate-access')"
                      >
                        <action-button type="view" :icon_only="true" small />
                      </router-link>

                      <router-link
                        :to="{ path: BACKEND_URL + '/certificates/edit/' + item.id, props: { id: item.id } }"
                        v-if="$can('certificate-edit')"
                      >
                        <action-button type="edit" :icon_only="true" small />
                      </router-link>

                      <action-button
                        type="delete"
                        :icon_only="true"
                        @click="delCertificate(item.id)"
                        v-if="$can('certificate-delete')"
                        small
                      />
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "participantView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      participant: {},
      address: {},

      courses: [],
      course_total: 0,
      course_show_loading: false,
      course_show_filter: false,
      course_refresh: false,
      course_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      course_headers: [
        { text: this.$t("courses.name"), value: "name" },
        { text: this.$t("courses.start_datetime"), value: "start_datetime" },
        { text: this.$t("courses.end_datetime"), value: "end_datetime" },
        { text: this.$t("global.actions"), value: "actions", width: "10%" }
      ],

      certificates: [],
      certificate_total: 0,
      certificate_show_loading: false,
      certificate_show_filter: false,
      certificate_refresh: false,
      certificate_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      certificate_headers: [
        { text: this.$t("certificates.title"), value: "title" },
        { text: this.$t("certificates.issued_date"), value: "issued_date" },
        { text: this.$t("certificates.issued_by"), value: "issued_by" },
        { text: this.$t("certificates.course_held_by"), value: "course_held_by" },
        { text: this.$t("global.actions"), value: "actions", width: "20%" }
      ]
    }
  },

  created() {
    axios
      .get(this.API_URL + "participant/" + this.id)
      .then((res) => {
        this.participant = res.data.data
        this.address = this.participant.address

        this.page_title = this.$t("participants.view_participant", {
          name: this.participant.first_name + " " + this.participant.last_name
        })

        this.course_list()
        this.certificate_list()
      })
      .catch((err) => console.log(err))
  },

  watch: {
    course_refresh: {
      handler() {
        if (this.course_refresh && this.participant.id) {
          this.course_list()
        }
      }
    },
    course_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.course_refresh = true
      }
    },
    certificate_refresh: {
      handler() {
        if (this.certificate_refresh && this.participant.id) {
          this.certificate_list()
        }
      }
    },
    certificate_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.certificate_refresh = true
      }
    }
  },

  computed: {
    computedDateofBirth() {
      return this.participant.date_of_birth ? this.moment.utc(this.participant.date_of_birth).format(this.DATE_FORMAT) : ""
    }
  },

  methods: {
    course_list() {
      this.course_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.course_pagination
      let query = this.$queryString(this.course_pagination, { participant_id: this.participant.id })

      axios.get(this.API_URL + "attendees?" + query).then((res) => {
        this.courses = res.data.data
        this.course_total = res.data.meta.total
        this.course_refresh = false
        this.course_show_loading = false

        this.course_pagination.page = res.data.meta.current_page
        this.course_pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    certificate_list() {
      this.certificate_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.certificate_pagination
      let query = this.$queryString(this.certificate_pagination, { participant_id: this.participant.id })

      axios.get(this.API_URL + "certificates?" + query).then((res) => {
        this.certificates = res.data.data
        this.certificate_total = res.data.meta.total
        this.certificate_refresh = false
        this.certificate_show_loading = false

        this.certificate_pagination.page = res.data.meta.current_page
        this.certificate_pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "participant/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/participants")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    delCertificate(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "certificate/" + id)
            .then((res) => {
              vm.certificate_list()
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
